module.exports = __webpack_public_path__ + "static/media/kira.76af9d66.png";